import { useTranslation } from "next-i18next";
import { LectureVideoItem } from "../lecutereVideoItem/lectureVideoItem";
import styles from "./lecturesVideos.module.scss";
import { useQILecturesVideos } from "@kunduz/feature-question-indexing";
import { LoadingSkeleton } from "@kunduz/ui";
import ArrowIcon from "@icons/arrowIcon.svg";
import { ReservedWords, getContentUrl } from "@kunduz/utility-common";
import Link from "next/link";

export const LecturesVideos = (props: Props) => {
  const { t } = useTranslation("questionIndexing");

  const { lecturesVideos, lecturesVideosError, lecturesVideosLoading } =
    useQILecturesVideos(props.id);

  if (
    lecturesVideos?.concepts?.length <= 0 ||
    lecturesVideosError ||
    !props.id
  ) {
    return null;
  }

  if (lecturesVideosLoading) {
    return <LoadingSkeleton style={{ width: "100%", height: 200 }} />;
  }

  return (
    <section id="related-learning-materials" className={styles.container}>
      <Link
        href={getContentUrl({
          lang: props.lang,
          segments: [lecturesVideos?.slug],
          contentType: ReservedWords.TR_CONTENT_MATERIAL,
        })}
        className={styles.title}
      >
        {t("question_indexing_learning_contents_header", {
          Module: lecturesVideos?.name,
        })}
        <span>
          {t(
            "question_indexing_question_recommendation_component_view_all_button",
          )}
          <ArrowIcon />
        </span>
      </Link>
      {lecturesVideos?.concepts?.map((concept, index) => {
        const _segment = concept.full_slug.slice(1, -1);
        return (
          <LectureVideoItem
            key={concept.id}
            description={concept.seo_meta.meta_desc}
            index={index + 1}
            slug={getContentUrl({
              lang: props.lang,
              segments: [_segment],
              contentType: ReservedWords.TR_CONTENT_MATERIAL,
            })}
            title={concept.name}
          />
        );
      })}
    </section>
  );
};

interface Props {
  id: number;
  lang: string;
}
